import * as z from "zod";

export const UserRoleEnum = {
    FieldTech: "field_tech",
    SuperUser: "super_user",
} as const;
export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum];
export const UserRoleEnumSchema = z.enum(UserRoleEnum);

export const UserRoleSchema = z
    .object({
        id: UserRoleEnumSchema.readonly(),
        label: z.string().trim(),
    })
    .brand<"UserRole">();

export type UserRole = z.output<typeof UserRoleSchema>;
